module.exports = {
  data: function() {
    return {
      typeAheadPointer: -1,
    }
  },
  watch: {
    filtered: function() {
      this.typeAheadPointer = 0
    },
  },
  methods: {
    typeAheadUp: function() {
      if (this.typeAheadPointer > 0) {
        this.typeAheadPointer--
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll()
        }
      }
    },
    typeAheadDown: function() {
      if (this.typeAheadPointer < this.filtered.length - 1) {
        this.typeAheadPointer++
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll()
        }
      }
    },
    typeAheadSelect: function() {
      if (this.filtered[this.typeAheadPointer]) {
        this.select(this.filtered[this.typeAheadPointer])
      }
    },
  },
}
